import * as typestyle from 'typestyle';
import * as csstips from 'csstips';
import * as gls from '../layout/gls';
import { maxPageContentWidth, maxLandingPageWidth, fontFamily, colors, fontSizes } from '../base/styles';
import * as React from 'react';
import { style, media } from 'typestyle';


/**
 * Sections that help with landing pages
 */
export class LandingPageSection extends React.PureComponent<{ backgroundColor: string; children?: React.ReactNode  }, {}>{
  render() {
    return <gls.Content style={{
      width: '100%', backgroundColor: this.props.backgroundColor
    }}>
      <gls.Content className={style(csstips.maxWidth(maxLandingPageWidth), csstips.horizontallyCenterSelf, csstips.padding(50), )}>
        <gls.Content className={style(csstips.maxWidth(maxPageContentWidth), csstips.horizontallyCenterSelf)}>
          {this.props.children}
        </gls.Content>
      </gls.Content>
    </gls.Content>
  }
}

/**
 * Spec:
 * - renders a hero image.
 * - the height is automatically driven from the image
 * - provides a newLayerParent for any children e.g. talky texts
 */
export class LandingPageHero extends React.PureComponent<{
  imgUrl: string,
  imgMediaClassName: string,
  maxWidth?: string,
  children?: React.ReactNode; 
}, {}>{;
  render() {
    return <gls.Content style={{
      /** To match the header color */
      backgroundColor: 'white'
    }}>
      <gls.Content className={typestyle.style(
        /** To allow us to position children like talky texts */
        csstips.layerParent,
        {
          width: '100%',
          margin: '0 auto',

          /** Otherwise horizonal scroll bars can appear on mobile devices when the image is too wide */
          overflow: 'hidden',
        },
        this.props.maxWidth && { maxWidth: this.props.maxWidth },
      )}>
        <img className={typestyle.classes(typestyle.style(
          {
            width: '100%',
            height: 'auto',
            transition: 'width .2s',
          }), this.props.imgMediaClassName)}
          src={this.props.imgUrl} />
        {this.props.children}
      </gls.Content>
    </gls.Content>
  }
}

/**
 * For talk bubbles
 * NOTE: Must be inside a LandingPageHero
 * NOTE: matches the design at https://auspost.com.au/mypost
 */
export class LandingPageTalky extends React.PureComponent<{
  /**
   * When put inside the hero
   **/
  /** max width */
  maxWidth: string;
  /** Position right or left. Vertically it is always centered */
  position: 'right' | 'left';

  children?: React.ReactNode; 

  /** Move out of hero at this level */
  moveTalkyOutAtWidth: number,
}, {}>{
  render() {
    const {props} = this;
    return <div className={style(
      { $debugName: 'talky-prevent-big-size' },
      typestyle.media({ minWidth: props.moveTalkyOutAtWidth },
        csstips.newLayer,
        csstips.horizontallyCenterSelf,
        {
          width: '100%',
          maxWidth: maxPageContentWidth,
        }),
    )}>
      <div className={style(
        {
          $debugName: 'talky',
          backgroundColor: 'white',

          /** NOTE: extra padding on bottom is intentional */
          padding: '40px 45px 50px 40px',
        },
        typestyle.media(
          { maxWidth: props.moveTalkyOutAtWidth - 1 }, { maxWidth: '100%', right: 'auto', left: 'auto' }
        ),
        typestyle.media(
          { minWidth: props.moveTalkyOutAtWidth },
          {
            borderRadius: '3px',

            /** Centered vertically in the parent */
            position: 'absolute',
            top: '50%',
            '-webkit-transform': 'translateY(-50%)',
            'transform': 'translateY(-50%)',
          },
          { maxWidth: props.maxWidth },
          props.position == 'left' ? { left: '0px' } : { right: '0px' }
        ),
      )}
        children={props.children} />
    </div>;
  }
}

export const LandingPageHeadingPrimary = ({text}: { text: string }) => {
  return (
    <div style={{ fontSize: '34px', fontFamily: fontFamily.auspost, color: colors.red }}>{text}</div>
  );
}


export const LandingPageHeadingSecondary = ({text}: { text: string }) => {
  return (
    <div style={{ fontSize: '34px', fontFamily: fontFamily.auspost, lineHeight: fontSizes.apLineHeight }}>{text}</div>
  );
}

export const LandingPageText = ({children}: { children?: React.ReactNode }) => {
  return <div style={{ fontSize: '18px', fontFamily: fontFamily.arial, lineHeight: '25px', color: colors.textColor }}>{children}</div>
}
